<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Ofertas</li>
  </ol>
</div>

<h4 class="page-title mb-0">
  <i class="fas fa-tags mr-2"></i>
  MeuCardapio Bio - Ofertas
</h4>

<!-- Loading -->
<div class="text-center p-5" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<!-- Alerta sem bio page -->
<div class="card" *ngIf="!carregando && !idBioPagina">
  <div class="card-body text-center p-5">
    <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
    <p class="text-muted">Configure primeiro a pagina Bio em "Configuracoes" antes de visualizar ofertas.</p>
    <a routerLink="/admin/bio/configuracoes" class="btn btn-primary">
      <i class="fas fa-cog mr-1"></i> Ir para Configuracoes
    </a>
  </div>
</div>

<!-- Layout com preview -->
<div class="bio-layout" *ngIf="!carregando && idBioPagina">
  <!-- Coluna esquerda: Conteudo -->
  <div class="form-panel">
    <div class="alert alert-info mb-3 d-flex align-items-center justify-content-between">
      <div>
        <i class="fas fa-info-circle mr-1"></i>
        As ofertas sao carregadas automaticamente dos produtos em promocao do seu cardapio.
        Para alterar as ofertas, configure precos promocionais no cadastro de produtos.
      </div>
      <div class="d-flex align-items-center ml-3" style="white-space: nowrap;">
        <span class="mr-2" style="font-size: 0.85em; font-weight: 600;">Exibir na Bio</span>
        <kendo-switch [ngModel]="exibirOfertas"
                      (valueChange)="toggleExibirOfertas()"
                      [onLabel]="''"
                      [offLabel]="''">
        </kendo-switch>
      </div>
    </div>

    <div class="d-flex justify-content-end mb-3">
      <button class="btn btn-outline-primary btn-sm" (click)="carregarProdutosPromocionais()">
        <i class="fas fa-sync-alt mr-1"></i> Atualizar Lista
      </button>
    </div>

    <!-- Estado vazio -->
    <div class="card" *ngIf="produtosPromocionais.length === 0">
      <div class="card-body text-center p-5">
        <i class="fas fa-tags fa-3x text-muted mb-3"></i>
        <h5 class="text-muted">Nenhum produto em promocao</h5>
        <p class="text-muted">Configure precos promocionais no cadastro de produtos para que as ofertas aparecam automaticamente na Bio.</p>
      </div>
    </div>

    <!-- Lista de produtos promocionais -->
    <div *ngIf="produtosPromocionais.length > 0">
      <div class="produto-card card mb-2" *ngFor="let produto of produtosPromocionais">
        <div class="card-body d-flex align-items-center py-2 px-3">
          <!-- Thumbnail da imagem -->
          <div class="oferta-thumbnail mr-3">
            <img *ngIf="produto.urlImagem" [src]="'/images/empresa/' + produto.urlImagem" alt="Produto" class="img-oferta" />
            <div *ngIf="!produto.urlImagem" class="img-placeholder">
              <i class="fas fa-image text-muted"></i>
            </div>
          </div>

          <!-- Info -->
          <div class="flex-grow-1">
            <strong class="d-block">{{produto.nome}}</strong>
            <small class="text-muted d-block" *ngIf="produto.descricao">
              {{produto.descricao | slice:0:60}}{{produto.descricao?.length > 60 ? '...' : ''}}
            </small>
            <div class="d-flex align-items-center mt-1">
              <span *ngIf="produto.precoOriginal" class="preco-antigo mr-2">
                R$ {{produto.precoOriginal | number:'1.2-2'}}
              </span>
              <span *ngIf="produto.precoPromocional" class="preco-novo">
                R$ {{produto.precoPromocional | number:'1.2-2'}}
              </span>
              <span *ngIf="produto.textoBadge" class="badge badge-oferta ml-2">
                {{produto.textoBadge}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna direita: Preview -->
  <div class="preview-panel">
    <div class="preview-header mb-3 text-center">
      <span class="text-muted font-weight-bold">Preview</span>
    </div>

    <!-- Toggle Mobile/Desktop -->
    <div class="preview-toggle mb-3 text-center">
      <div class="btn-group">
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'mobile', 'btn-outline-primary': modoPreview !== 'mobile'}"
                (click)="modoPreview = 'mobile'">
          <i class="fas fa-mobile-alt mr-1"></i> Mobile
        </button>
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'desktop', 'btn-outline-primary': modoPreview !== 'desktop'}"
                (click)="modoPreview = 'desktop'">
          <i class="fas fa-desktop mr-1"></i> Desktop
        </button>
      </div>
    </div>

    <!-- Frame do celular -->
    <div class="phone-frame" [ngClass]="{'desktop-frame': modoPreview === 'desktop'}">
      <div class="phone-notch" *ngIf="modoPreview === 'mobile'"></div>
      <div class="phone-screen">
        <iframe *ngIf="urlPreview"
                [src]="urlPreview"
                class="preview-iframe"
                frameborder="0"
                scrolling="yes">
        </iframe>
        <div *ngIf="!urlPreview" class="no-preview">
          <i class="fas fa-eye-slash fa-2x text-muted mb-2"></i>
          <p class="text-muted">Configure o slug para visualizar o preview</p>
        </div>
      </div>
      <div class="phone-home-bar" *ngIf="modoPreview === 'mobile'"></div>
    </div>

    <div class="mt-3 text-center" *ngIf="urlPreview">
      <button class="btn btn-outline-secondary btn-sm mr-2" (click)="recarregarPreview()">
        <i class="fas fa-sync-alt mr-1"></i> Atualizar Preview
      </button>
      <button class="btn btn-outline-secondary btn-sm" (click)="abrirEmNovaAba()">
        <i class="fas fa-external-link-alt mr-1"></i> Abrir Pagina
      </button>
    </div>
  </div>
</div>
